import Blue from "~/core";
import { addEvents, domLoaded, createElement, screen } from "../utils";
new Blue({
  name: "Home Hero",
  selector: ".home-hero",
  setup(hero) {
    const heroBackground = hero.querySelector(".home-hero__background");
    const backgroundImage = hero.querySelector(
      ".home-hero__background-image"
    );
    const videoSource = backgroundImage.dataset.videoSrc;
    const videoMobileSource = backgroundImage.dataset.videoMobile;
    if (videoSource == null || videoMobileSource == null) return;
    domLoaded(() => {
      createVideo.call(hero);
    });
    function createVideo() {
      let isDesktop;
      const videoContainer = createElement({
        tag: "div",
        attributes: { class: "home-hero__background-video" },
      });
      const video = createElement({
        tag: "video",
        attributes: {
          class: "home-hero__video",
          autoplay: "",
          loop: "",
          muted: "",
          playsinline: ""
        },
      });
      const playButton = createElement({
        tag: "button",
        attributes: {
          type: "button",
          class: "home-hero__video-play is-playing",
        },
      });
      const buttonLabel = createElement({
        tag: "span",
        attributes: {
          class: "hide-visually",
        },
        text: "Play or Pause Video",
      });
      const playIcon = createElement({
        tag: "i",
        attributes: {
          class: "glyph-play",
        },
      });
      const pauseIcon = createElement({
        tag: "i",
        attributes: {
          class: "glyph-pause",
        },
      });
      heroBackground.insertAdjacentElement("afterbegin", videoContainer);
      videoContainer.insertAdjacentElement("afterbegin", video);
      playButton.insertAdjacentElement("afterbegin", buttonLabel);
      playButton.insertAdjacentElement("afterbegin", playIcon);
      playButton.insertAdjacentElement("afterbegin", pauseIcon);
      playButton.addEventListener("click", toggleVideo);
      hero.insertAdjacentElement("beforeend", playButton);
      video.muted = true;
      video.autoplay = true;
      video.loop = true;
      if (screen.lg.matches) {
        video.src = videoSource;
      } else {
        video.src = videoMobileSource;
      }
      video.load();
      video.onloadeddata = () => backgroundImage.remove();
      function toggleVideo() {
        if (video.paused) {
          playButton.classList.add("is-playing");
          playButton.classList.remove("is-paused");
          video.play();
        } else {
          playButton.classList.add("is-paused");
          playButton.classList.remove("is-playing");
          video.pause();
        }
      }
    }
  },
});